import React, { Component } from "react";
import PropTypes from "prop-types";

class LikeWishResults extends Component {
  render() {
    const { title, items, header } = this.props;

    return (
      <div className="peer-evaluation-like-wish-results">
        {title && (
          <h5
            className="title"
            dangerouslySetInnerHTML={
              { __html: title }
            } />
        )}
        {header}
        <div className="like-wish-items">
          {
            items.map((item, index) => (
              <div key={index} className={item.name ? 'like-wish-item' : 'like-wish-item-feedback'}>
                {item.name && <div className="like-wish-item-name-block"><span>{item.name}</span></div>}
                <div className={item.name ? 'like-wish-item-text-block' : ''}><span>{item.text}</span></div>
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}

LikeWishResults.defaultProps = {
  title: "",
  items: []
};

LikeWishResults.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  items: PropTypes.array,
};

export default LikeWishResults;



// WEBPACK FOOTER //
// ./src/components/peer-evaluation/like-wish-results/index.js